export const AUTH_TOKEN = 'auth-token'
export const USER = 'user'
